export default function BlogSection() {
  const featuredPost = {
    title: 'デザインシステムがもたらす組織変革：一貫性と効率性の両立',
    category: 'Design System',
    date: '2024年1月15日',
    readTime: '8分',
    excerpt: 'デザインシステムは単なるコンポーネントライブラリではありません。組織全体のデザイン品質を向上させ、開発効率を劇的に改善する戦略的な投資です。本記事では、実際のプロジェクトで得た知見をもとに、デザインシステム構築のベストプラクティスと、組織に与える影響について詳しく解説します。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20design%20system%20components%20layout%20on%20dark%20interface%2C%20organized%20UI%20component%20library%20with%20golden%20accent%20colors%2C%20professional%20design%20tokens%20and%20style%20guide%20visualization%2C%20systematic%20design%20elements%20arranged%20on%20charcoal%20background%2C%20sophisticated%20design%20workflow%20illustration&width=800&height=500&seq=blog-featured-001&orientation=landscape'
  };

  const highlightedPosts = [
    {
      title: 'ユーザーリサーチの実践：定性調査と定量調査の使い分け',
      category: 'UX Research',
      date: '2024年1月10日',
      readTime: '6分',
      image: 'https://readdy.ai/api/search-image?query=UX%20research%20process%20visualization%20with%20user%20interview%20notes%20and%20data%20analytics%2C%20qualitative%20and%20quantitative%20research%20methods%20illustration%2C%20professional%20user%20testing%20setup%20with%20beige%20and%20navy%20color%20scheme%20on%20dark%20background&width=500&height=400&seq=blog-highlight-001&orientation=landscape'
    },
    {
      title: 'アクセシビリティを考慮したカラーパレット設計',
      category: 'Accessibility',
      date: '2024年1月5日',
      readTime: '5分',
      image: 'https://readdy.ai/api/search-image?query=Accessible%20color%20palette%20design%20with%20WCAG%20contrast%20ratio%20examples%2C%20inclusive%20design%20color%20swatches%20with%20warm%20beige%20and%20gold%20tones%2C%20professional%20accessibility%20guidelines%20visualization%20on%20dark%20background&width=500&height=400&seq=blog-highlight-002&orientation=landscape'
    }
  ];

  const recentPosts = [
    {
      title: 'Figmaプラグイン開発入門：デザインワークフローの自動化',
      category: 'Tools',
      date: '2023年12月28日',
      readTime: '7分',
      image: 'https://readdy.ai/api/search-image?query=Figma%20plugin%20development%20interface%20with%20code%20editor%20and%20design%20tools%2C%20workflow%20automation%20visualization%2C%20modern%20design%20tool%20integration%20with%20teal%20and%20gold%20accents%20on%20dark%20background&width=400&height=400&seq=blog-recent-001&orientation=squarish'
    },
    {
      title: 'マイクロインタラクションで体験価値を高める',
      category: 'Interaction Design',
      date: '2023年12月20日',
      readTime: '5分',
      image: 'https://readdy.ai/api/search-image?query=Micro-interactions%20animation%20examples%20in%20modern%20UI%2C%20subtle%20button%20hover%20effects%20and%20transitions%2C%20delightful%20user%20interface%20details%20with%20smooth%20animations%2C%20sophisticated%20interaction%20design%20on%20dark%20background&width=400&height=400&seq=blog-recent-002&orientation=squarish'
    },
    {
      title: 'レスポンシブデザインの新しいアプローチ：Container Queries',
      category: 'Frontend',
      date: '2023年12月15日',
      readTime: '6分',
      image: 'https://readdy.ai/api/search-image?query=Responsive%20web%20design%20with%20container%20queries%20visualization%2C%20modern%20CSS%20layout%20techniques%2C%20adaptive%20component%20design%20across%20multiple%20device%20screens%20with%20beige%20and%20navy%20colors%20on%20dark%20background&width=400&height=400&seq=blog-recent-003&orientation=squarish'
    }
  ];

  return (
    <section id="blog" className="relative py-24 lg:py-32 bg-gradient-to-b from-[#0f1419] to-[#1a1a1a]">
      <div className="absolute right-0 top-0 w-1/2 h-1/2 opacity-5">
        <svg className="w-full h-full" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,50 Q25,30 50,50 T100,50" fill="none" stroke="#c9a96e" strokeWidth="0.5" opacity="0.3"/>
          <path d="M0,60 Q25,40 50,60 T100,60" fill="none" stroke="#c9a96e" strokeWidth="0.5" opacity="0.3"/>
          <path d="M0,70 Q25,50 50,70 T100,70" fill="none" stroke="#c9a96e" strokeWidth="0.5" opacity="0.3"/>
        </svg>
      </div>

      <div className="relative z-10 px-6 lg:px-12">
        <div className="text-center mb-12">
          <h2 className="text-5xl lg:text-6xl font-thin text-[#f5f5f0] mb-4">Latest Insights</h2>
          <p className="text-sm text-[#d4c5b9]/70">デザイン思考と業界トレンド</p>
          <a
            href="#blog"
            className="inline-flex items-center gap-2 mt-6 text-sm text-[#c9a96e] hover:text-[#d4c5b9] transition-colors duration-300 cursor-pointer"
          >
            <span>すべて見る</span>
            <i className="ri-archive-line"></i>
          </a>
        </div>

        <div className="grid lg:grid-cols-5 gap-6 mb-12">
          <div className="lg:col-span-3">
            <div className="group relative overflow-hidden rounded-3xl bg-[#252525] h-full cursor-pointer">
              <div className="relative h-80 overflow-hidden">
                <img
                  src={featuredPost.image}
                  alt={featuredPost.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1a1a1a] via-[#1a1a1a]/70 to-transparent"></div>
                <h3 className="absolute bottom-6 left-6 right-6 text-2xl lg:text-3xl font-bold text-white leading-tight">
                  {featuredPost.title}
                </h3>
              </div>

              <div className="p-6 space-y-4">
                <div className="flex items-center gap-4 text-xs text-[#f5f5f0]/60">
                  <span className="px-3 py-1 bg-[#c9a96e] text-[#1a1a1a] rounded-full font-medium">
                    {featuredPost.category}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {featuredPost.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {featuredPost.readTime}
                  </span>
                </div>

                <p className="text-sm leading-relaxed text-[#f5f5f0]/70">
                  {featuredPost.excerpt}
                </p>

                <button className="px-6 py-3 border-2 border-[#c9a96e]/30 text-[#c9a96e] rounded-full text-sm font-medium hover:bg-[#c9a96e] hover:text-[#1a1a1a] hover:border-[#c9a96e] transition-all duration-300 whitespace-nowrap cursor-pointer">
                  続きを読む
                </button>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2 space-y-6">
            {highlightedPosts.map((post, index) => (
              <div
                key={index}
                className="group relative overflow-hidden rounded-2xl bg-[#252525] cursor-pointer hover:-translate-y-1 transition-transform duration-300"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#1a1a1a]/90 to-transparent"></div>
                </div>

                <div className="p-5 space-y-3">
                  <span className="inline-block px-3 py-1 bg-[#2a2a2a] text-[#c9a96e] text-xs rounded-full">
                    {post.category}
                  </span>

                  <h4 className="text-lg font-semibold text-[#d4c5b9] leading-tight group-hover:text-[#c9a96e] transition-colors duration-300">
                    {post.title}
                  </h4>

                  <div className="flex items-center gap-3 text-xs text-[#f5f5f0]/50">
                    <span>{post.date}</span>
                    <span>•</span>
                    <span>{post.readTime}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative">
          <div className="absolute left-0 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-[#c9a96e]/30 to-transparent hidden lg:block"></div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 lg:pl-12">
            {recentPosts.map((post, index) => (
              <div
                key={index}
                className="group relative cursor-pointer"
              >
                <div className="bg-[#252525] rounded-2xl overflow-hidden hover:-translate-y-2 transition-all duration-500 border border-[#c9a96e]/10 hover:border-[#c9a96e]/30">
                  <div className="relative h-56 overflow-hidden">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                    />
                  </div>

                  <div className="p-5 space-y-3">
                    <span className="inline-block px-3 py-1 bg-[#2a2a2a] text-[#c9a96e] text-xs rounded-full">
                      {post.category}
                    </span>

                    <h4 className="text-lg font-semibold text-[#d4c5b9] leading-tight group-hover:text-[#c9a96e] transition-colors duration-300 line-clamp-2">
                      {post.title}
                    </h4>

                    <div className="flex items-center justify-between text-xs text-[#f5f5f0]/50">
                      <span>{post.date}</span>
                      <span>{post.readTime}</span>
                    </div>

                    <a
                      href="#blog"
                      className="inline-flex items-center gap-2 text-sm text-[#c9a96e] hover:gap-3 transition-all duration-300"
                    >
                      <span>読む</span>
                      <i className="ri-arrow-right-line"></i>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}